'use client';

import { c as _c } from "react/compiler-runtime";
import { type ToastOptions, useToastState } from '@react-stately/toast';
import { createContext, type PropsWithChildren, useCallback, useContext, useMemo } from 'react';
import { createPortal } from 'react-dom';
import { ToastRegion } from '../components/toast-region/toast-region';
import { type ToastContent } from '../constants/constants';
type ToastContextValues = {
  addToast: (toastData: ToastContent, options: ToastOptions) => void;
};
const ToastContext = createContext<ToastContextValues | undefined>(undefined);
export const GlobalToastContextProvider = t0 => {
  const $ = _c(15);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      maxVisibleToasts: 3
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const state = useToastState(t1);
  let t2;
  if ($[4] !== state) {
    t2 = (toastData, options) => {
      const isToastMessageUnique = !state.visibleToasts.some(item => item.content.description === toastData.description);
      if (isToastMessageUnique) {
        state.add(toastData, options);
      }
    };
    $[4] = state;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const addToast = t2;
  let t3;
  if ($[6] !== addToast) {
    t3 = {
      addToast
    };
    $[6] = addToast;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const contextValue = t3;
  let t4;
  if ($[8] !== props || $[9] !== state) {
    t4 = state.visibleToasts.length > 0 ? createPortal(<ToastRegion {...props} state={state} />, document.body) : null;
    $[8] = props;
    $[9] = state;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== children || $[12] !== contextValue || $[13] !== t4) {
    t5 = <ToastContext.Provider value={contextValue}>{children}{t4}</ToastContext.Provider>;
    $[11] = children;
    $[12] = contextValue;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
export const useGlobalToastContext = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};